<!--
 * @Author: your name
 * @Date: 2021-04-20 11:57:04
 * @LastEditTime: 2021-04-21 14:12:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yijiu_shopmall_h5\src\views\orderDetails.vue
-->
<template>
  <div class="order_infos">
    <div class="orderbox">
      <div class="order_topcon">
        <!-- <p>{{detailInfo.status_cn}}</p> -->
        <div
          class="ordermoney"
        >{{detailInfo.c_status == 1 ? '请耐心等待' : detailInfo.c_status == 2 ? '订单已驳回' :detailInfo.c_status == 3 ? '订单已取消' :detailInfo.c_status == 4 ? '审核通过' :detailInfo.c_status == 5 ? '等待平台确认收货' :detailInfo.c_status == 1 ? '售后已完成' : ''}}</div>
      </div>
      <div class="order_adrress" v-if="detailInfo.stage_tips.length > 0">
        <div class="order_kd">
          <p>{{detailInfo.stage_tips[0].notes}}</p>
          <span class="iconfont iconnext"></span>
        </div>
      </div>
      <div class="main3 flex aliten_center" v-if="JSON.stringify(defaultAddress) != '{}'">
        <img class="n_biao" :src="imgPath+'yj_icon-map.png'" alt />
        <div class="aliten_center flex space_bettw">
          <div class="n_margin">
            <div class="wrap3">
              <span class="n_name">{{defaultAddress.consignee}}</span>
              &nbsp;&nbsp;
              <span class="n_phone">{{defaultAddress.phone}}</span>
            </div>
            <div
              class="n_provi"
              v-if="defaultAddress.address_detail"
            >{{defaultAddress.address_detail.level_1_name + defaultAddress.address_detail.level_2_name + defaultAddress.address_detail.level_3_name + defaultAddress.address_detail.level_4_name + defaultAddress.address}}</div>
          </div>
          <span class="iconfont iconnavigate-right"></span>
        </div>
      </div>
      <div class="order_x_info" v-if="detailInfo.c_status == 5">
        <ul>
          <li>
            <p>发货信息</p>
            <p class="n_textred">更改运单</p>
          </li>
          <li>
            <p>快递单号</p>
            <p>
              <span style="paddingRight:10px">{{detailInfo.back_ship_sn}}</span>
              <span class="n_textred" @click="copyTextFg(detailInfo.back_ship_sn)">复制</span>
            </p>
          </li>
          <li>
            <p>快递公司</p>
            <p>{{detailInfo.back_ship_name}}</p>
          </li>
        </ul>
      </div>

      <div
        class="order_x_info"
        v-if="(detailInfo.c_status == 4 || detailInfo.c_status == 5) && detailInfo.consignee_address"
      >
        <h2>回寄地址信息</h2>
        <ul>
          <li>
            <p>寄回地址</p>
            <p class="n_textred">{{detailInfo.consignee_address}}</p>
          </li>
          <li>
            <p>收件人</p>
            <p>{{detailInfo.consignee_name}}</p>
          </li>
          <li>
            <p>联系电话</p>
            <p>{{detailInfo.consignee_phone}}</p>
          </li>
          <li>
            <p class="n_content">温馨提示</p>
            <p></p>
          </li>
          <div>
            <p class="n_content">1.请将产品和配件一并退回（有赠品和发票一并退回）</p>
          </div>
          <div>
            <p class="n_content">2.请确认商品有无划痕，配件是否齐全，包装有无破损</p>
          </div>
          <div>
            <p class="n_content">3.请勿使用到付或平邮，以免商家拒签货物</p>
          </div>
        </ul>
      </div>
      <div class="order_x_info">
        <ul>
          <li>
            <p>退款金额</p>
            <p class="n_textred">¥{{detailInfo.refund_price}}</p>
          </li>
          <li>
            <p>商品金额</p>
            <p>¥ {{detailInfo.goods_amount}}</p>
          </li>
          <li>
            <p>运费金额</p>
            <p>¥ {{detailInfo.ship_amount}}</p>
          </li>
        </ul>
      </div>
      <div class="order_goods">
        <img :src="detailInfo.goods_image" alt />
        <div>
          <p>{{detailInfo.goods_name}}</p>
          <b>{{detailInfo.specification}}*{{detailInfo.num}}</b>
          <span>
            <i>￥</i>
            {{detailInfo.goods_price}}
          </span>
        </div>
      </div>

      <div class="order_x_info">
        <h2>售后信息</h2>
        <ul>
          <li>
            <p>售后单号</p>
            <p>{{detailInfo.apply_sn}}</p>
          </li>
          <li>
            <p>申请时间</p>
            <p>{{detailInfo.apply_time_cn}}</p>
          </li>
          <li>
            <p>售后类型</p>
            <p>{{detailInfo.apply_type_cn}}</p>
          </li>
          <li>
            <p>申请原因</p>
            <p>{{detailInfo.caused}}</p>
          </li>
          <li>
            <p>联系人</p>
            <p>{{detailInfo.send_back_name}}</p>
          </li>
          <li>
            <p>联系电话</p>
            <p>{{detailInfo.send_back_phone}}</p>
          </li>
        </ul>
      </div>
    </div>
    <!--底部按钮-->
    <div class="orderfoot" v-if="detailInfo.is_cancel == 1 || detailInfo.is_edit == 1">
      <p
        class="n_btn"
        v-if="detailInfo.is_cancel == 1"
        @click="cancelApplyFg(detailInfo.apply_sn)"
      >撤销申请</p>
      <p
        class="n_btn"
        v-if="detailInfo.is_edit == 1"
        @click="$router.push({path: './returnGoodsForm',query: {refundId: detailInfo.apply_type,orderDetailId:detailInfo.order_detail_id,orderId:detailInfo.order_detail_id,sn:detailInfo.apply_sn,type:'edit',max_edit_num:detailInfo.max_edit_num,is_edit_num:detailInfo.is_edit_num}})"
      >修改申请</p>
      <!-- <p
        v-if="detailInfo.c_status == 4"
        class="n_btn"
        @click="$router.push({path: './expressage' ,query: {orderSn: id,apply_sn: detailInfo.apply_sn}})"
      >填写快递信息</p>-->
      <!-- <p class="n_btn" v-if="detailInfo.c_status == 2">修改申请原因</p> -->
      <!-- <p class="button">联系客服</p> -->
    </div>
    <div class="orderfoot" v-if="detailInfo.is_express == 1">
      <p
        v-if="detailInfo.c_status == 4"
        class="n_btn"
        @click="$router.push({path: './expressage' ,query: {orderSn: id,sn: detailInfo.apply_sn,orderDetailId:detailInfo.order_detail_id}})"
      >填写快递信息</p>
      <!-- <p class="n_btn" v-if="detailInfo.c_status == 2">修改申请原因</p> -->
      <!-- <p class="button">联系客服</p> -->
    </div>
  </div>
</template>

<script>
import { Toast, Dialog } from 'vant'
import { copyText } from '../../public/regular.js'
export default {
  name: 'orderDetails',
  data() {
    return {
      defaultAddress: {}, //默认地址
      detailInfo: {},
      id: '',
      refundInfo: {},
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getDetail()
    this.getDefaultAddress()
  },
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    copyTextFg(text) {
      copyText(text)
    },
    //售后详情
    async getDetail() {
      let res = await this.http('ClientOrder.refundApplyDetail', {
        order_detail_id: this.$route.query.id,
        apply_sn: this.$route.query.sn,
      })
      this.getRefundType()
      this.detailInfo = res.content
      console.log(res)
    },
    //获取订单详情
    getOrderDetail() {
      this.http('ClientOrder.childDetail', { order_id: this.id }).then(
        (res) => {
          if (res.status == 200) {
            console.log(res)
            this.orderDetails = res.content
          } else {
            Toast(res.msg)
          }
        }
      )
    },
    //撤销申请
    cancelApplyFg(id) {
      Dialog.confirm({
        message: '确定是否撤销申请',
      })
        .then(() => {
          this.http('ClientOrder.cancelApply', { apply_sn: id }).then((res) => {
            if (res.status == 200) {
              this.page = 0
              this.list = []
              this.getDetail()
              this.getOrderDetail()
              Toast('撤销申请成功')
            } else {
              Toast(res.msg)
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    //获取默认地址
    async getDefaultAddress() {
      let res = await this.http('ClientAddress.getDefaultAddress', {})
      if (res.status == 200) {
        this.defaultAddress = res.content
      } else {
        Dialog.alert({
          message: res.msg,
        }).then(() => {
          this.$router.push({
            path: '../cityList',
            query: { type: 'comfirm', param: this.$route.query.param },
          })
          // on close
        })
        this.defaultAddress = {}
      }
    },
    jump() {
      console.log('111')
      this.$router.push({
        path: '../cityList',
        query: { type: 'comfirm', param: this.$route.query.param },
      })
    },
    async getRefundType() {
      let res = await this.http('ClientOrder.getRefundType', {
        order_detail_id: this.id,
      })
      this.refundInfo = res.content
      console.log(res)
    },
  },
}
</script>
<style>
.orderbox {
  padding-bottom: 150px;
}
</style>
<style lang="scss" scoped>
.order_infos {
  background: #f8f8f8
    url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yi_bg_order.png')
    no-repeat center top;
  background-size: 750px 259px;
  min-height: 100vh;
  .order_topcon {
    color: #fff;
    font-size: 38px;
    padding-top: 60px;
    p {
      line-height: 50px;
      // background: url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yj_time.png')
      //   no-repeat 270px center;
      background-size: 50px 50px;
      text-align: center;
      text-indent: 1em;
      margin-bottom: 28px;
    }
    .ordermoney {
      font-size: 32px;
      color: #ffffff;
      text-align: center;
    }
  }
  .order_goods {
    position: relative;
    width: 710px;
    height: 188px;
    background: #ffffff;
    border-radius: 14px;
    margin: 20px auto 0;
    img {
      float: left;
      width: 140px;
      height: 140px;
      border-radius: 10px;
      margin: 24px;
    }
    div {
      width: 476px;
      margin-top: 24px;
      float: left;
      p {
        width: 476px;
        font-size: 28px;
        color: #333333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 10px;
      }
      b {
        font-size: 24px;
        color: #999;
        padding: 4px 10px;
        background: #f2f2f2;
        border-radius: 8px;
        display: inline-block;
        margin-bottom: 10px;
      }
      span {
        display: block;
        color: #f0240e;
        font-size: 34px;
        i {
          font-size: 28px;
        }
      }
    }
    .apply {
      position: absolute;
      right: 20px;
      bottom: 20px;
      width: 158px;
      height: 54px;
      line-height: 54px;
      text-align: center;
      font-size: 26px;
      background: #ffffff;
      border-radius: 200px;
      border: 2px solid #dcdee0;
    }
  }
  .order_x_info {
    width: 710px;
    background: #ffffff;
    border-radius: 14px;
    margin: 20px auto 0;
    .n_textred {
      color: rgba(240, 36, 14, 1) !important;
    }
    h2 {
      color: #333333;
      font-size: 28px;
      line-height: 72px;
      padding: 0 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
    }
    ul {
      padding: 0 30px 20px;
      li {
        display: flex;
        justify-content: space-between;
        line-height: 80px;
        font-size: 28px;
        p:nth-child(2) {
          width: 400px;
          text-align: right;
        }
      }
    }
  }
  .order_adrress {
    width: 650px;
    background: #ffffff;
    border-radius: 14px;
    margin: 15px auto 20px;
    padding: 24px 30px;
    .order_kd {
      color: #333333;
      font-size: 26px;
      display: flex;
      justify-content: space-between;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      p {
        word-break: break-all;
      }
    }
    .xx_adr {
      background: url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yj_icon-map.png')
        no-repeat left center;
      background-size: 50px 50px;
      margin-top: 25px;
      font-size: 24px;
      padding-left: 65px;
    }
  }
  .orderfoot {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 750px;
    height: 100px;
    background: #fff;
    border-top: 1px solid #eee;
    .button {
      float: right;
      margin-right: 20px;
      width: 200px;
      height: 64px;
      background: #ffffff;
      border-radius: 200px;
      border: 2px solid #dcdee0;
      text-align: center;
      font-size: 28px;
      line-height: 64px;
      margin-top: 14px;
    }
  }
  .n_btn {
    float: right;
    margin-right: 20px;
    width: 200px;
    height: 64px;
    border-radius: 200px;
    background: #ff9f9f linear-gradient(184deg, #ff3333 0%, #ff5720 100%);
    border: 2px solid #dcdee0;
    text-align: center;
    color: rgba(255, 255, 255, 1);
    font-size: 28px;
    line-height: 64px;
    margin-top: 14px;
  }
  .n_content {
    margin-top: 18px;
    font-size: 26px;
    color: #999999;
  }
}
.main3 {
  width: 710px;
  box-sizing: border-box;
  background: #ffffff;
  padding: 28px 26px;
  margin: 20px auto 0;
}
.aliten_center {
  align-items: center;
}
.n_margin {
  margin-left: 30px;
}
.n_name {
  font-size: 32px;
  color: #333333;
}
.n_phone {
  font-size: 24px;
  color: #999999;
}
.n_provi {
  font-size: 24px;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.iconnavigate-right {
  font-size: 40px;
}
.space_bettw {
  justify-content: space-between;
  width: 100%;
}
</style>